import { Helmet } from "react-helmet";

export default function TermsAndConditions() {
  return (
    <>
      <Helmet>
        <meta charset="UTF-8" />
        <title>Terms & Conditions — S.Kumars</title>
      </Helmet>

      <iframe
        src="/pages/terms-and-conditions.html"
        title="Terms & Conditions"
        style={{ width: "100%", minHeight: "100vh", border: "none" }}
      />
    </>
  );
}
